// extracted by mini-css-extract-plugin
export default {"loader":"SingleProject_loader__0m8Cr","content":"SingleProject_content__He+6T","updateForm":"SingleProject_updateForm__C9co3"};